import { css } from "lit-element";

export const StofwareAccordion = css`
	.accordion-title {
		cursor: pointer;
		line-height: 40px;
		padding: 5px 20px;
		border-bottom: 1px solid var(--app-lightgrey);
	}
	.accordion-title p {
		font-weight: bold;
	}
	.accordion-child .accordion-title {
		height: 19px;
		line-height: 19px;
		padding: 20px 0;
		margin: 0 15px;
		font-size: 14px;
	}

	.accordion-child .accordion-title icon {
		margin: 0;
	}

	.accordion-child .accordion-title icon svg {
		width: 14px;
	}

	.accordion-child .accordion-title p {
		margin: 0;
		font-weight: bold;
	}

	.accordion .accordion-content {
		padding: 0 20px;
		margin: 0 -15px;
	}
	.accordion-child .accordion-content {
		padding: 0 15px;
		margin: 0 -15px;
	}
	.accordion {
		height: 72px;
		overflow: hidden;
	}

	.accordion.accordion-child {
		height: 60px;
	}
	.accordion.accordion-child.active,
	.accordion.active {
		height: auto;
	}
`;
